import PropTypes from 'prop-types'
import React from 'react'

const BlogPreview = ({ className, title, description, imageUrl }) => (
  <div className={className}>
    <img src={imageUrl} class="full-w" alt=""></img>
    <h1
      className="subtitle border-b-l brand-color"
      style={{ marginBottom: '12px' }}
    >
      {title}
    </h1>
    <p className="is-size-6">{description}</p>
  </div>
)

BlogPreview.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
}

export default BlogPreview
